import { compose } from 'recompose';

import PayerInfoBlockView from './PayerInfoBlockView';

export default compose()(PayerInfoBlockView);
